export default __webpack_public_path__ + "static/media/oh-du-goldigs-suenneli.081a01d1.webp";